/* ------------------------------------------------------------------------
	* LC Switch
	* superlight jQuery plugin improving forms look and functionality
	*
	* @version: 	1.1
	* @requires:	jQuery v1.7 or later
	* @author:		Luca Montanari (LCweb)
	* @website:		https://lcweb.it

	* Licensed under the MIT license
------------------------------------------------------------------------- */

/* global jQuery */

(function ($) {
  'use strict'
  if (typeof ($.fn.lc_switch) !== 'undefined') { return false } // prevent multiple script inits

  $.fn.lc_switch = function (onText, offText) {
    // destruct
    $.fn.lcs_destroy = function () {
      $(this).each(function () {
        var $wrap = $(this).parents('.lcs_wrap')

        $wrap.children().not('input').remove()
        $(this).unwrap()
      })

      return true
    }

    // set to ON
    $.fn.lcs_on = function () {
      $(this).each(function (i, v) {
        var $wrap = $(this).parents('.lcs_wrap')
        var $input = $wrap.find('input')

        // if is already on - skip
        if ($wrap.find('.lcs_on').length) {
          return true
        }

        (typeof ($.fn.prop) === 'function') ? $input.prop('checked', true) : $input.attr('checked', true)

        $input.trigger('lcs-on')
        $input.trigger('lcs-statuschange')
        $wrap.find('.lcs_switch').removeClass('lcs_off').addClass('lcs_on')

        // if radio - disable other ones
        if ($wrap.find('.lcs_switch').hasClass('lcs_radio_switch')) {
          var fName = $input.attr('name')
          $wrap.parents('form').find('input[name=' + fName + ']').not($input).lcs_off()
        }
      })

      return true
    }

    // set to OFF
    $.fn.lcs_off = function () {
      $(this).each(function () {
        var $wrap = $(this).parents('.lcs_wrap')
        var $input = $wrap.find('input')

        // if is already off - skip
        if (!$wrap.find('.lcs_on').length) {
          return true
        }

        // uncheck
        (typeof ($.fn.prop) === 'function') ? $input.prop('checked', false) : $input.attr('checked', false)

        $input.trigger('lcs-off')
        $input.trigger('lcs-statuschange')
        $wrap.find('.lcs_switch').removeClass('lcs_on').addClass('lcs_off')
      })

      return true
    }

    // toggle status
    $.fn.lcs_toggle = function () {
      $(this).each(function () {
        // not for radios
        if ($(this).hasClass('lcs_radio_switch')) {
          return true
        }

        ($(this).is(':checked')) ? $(this).lcs_off() : $(this).lcs_on()
      })

      return true
    }

    // disable
    $.fn.lcs_disable = function (disable) {
      $(this).each(function () {
        const wrap = $(this).parents('.lcs_wrap')
        const sw = wrap.children('.lcs_switch')
        if (disable) {
          sw.addClass('lcs_disabled')
        } else {
          sw.removeClass('lcs_disabled')
        }
      })
    }

    // construct
    return this.each(function () {
      // check against double init
      if (!$(this).parent().hasClass('lcs_wrap')) {
        // default texts
        var ckdOnTxt = (typeof (onText) === 'undefined') ? 'ON' : onText
        var ckdOffTxt = (typeof (offText) === 'undefined') ? 'OFF' : offText

        // labels structure
        var onLabel = (ckdOnTxt) ? '<div class="lcs_label lcs_label_on">' + ckdOnTxt + '</div>' : ''
        var offLabel = (ckdOffTxt) ? '<div class="lcs_label lcs_label_off">' + ckdOffTxt + '</div>' : ''

        // default states
        var disabled = !!($(this).is(':disabled'))
        var active = !!($(this).is(':checked'))

        var statusClasses = ''
        statusClasses += (active) ? ' lcs_on' : ' lcs_off'
        if (disabled) {
          statusClasses += ' lcs_disabled'
        }

        // wrap and append
        var structure =
                    '<div class="lcs_switch ' + statusClasses + '">' +
                    '<div class="lcs_cursor"></div>' +
                    onLabel + offLabel +
                    '</div>'

        if ($(this).is(':input') && ($(this).attr('type') === 'checkbox' || $(this).attr('type') === 'radio')) {
          $(this).wrap('<div class="lcs_wrap"></div>')
          $(this).parent().append(structure)

          $(this).parent().find('.lcs_switch').addClass('lcs_' + $(this).attr('type') + '_switch')
        }
      }
    })
  }

  // handlers
  $(document).ready(function () {
    // on click
    $(document).on('click tap', '.lcs_wrap', function (e) {
      const disabled = !!($(this).children('input').is(':disabled'))
      if (!disabled) {
        const el = $(this).children('.lcs_switch')
        if (el.hasClass('lcs_on')) {
          if (!el.hasClass('lcs_radio_switch')) { // not for radio
            el.lcs_off()
          }
        } else {
          el.lcs_on()
        }
      }
    })

    // on checkbox status change
    $(document).on('change', '.lcs_wrap input', function () {
      ($(this).is(':checked')) ? $(this).lcs_on() : $(this).lcs_off()
    })
  })
})(jQuery)
